/* Swiss theme behaviour: measured motion only. */
(function () {
  var root = document.documentElement;
  var KEY = 'swiss:motion';

  function systemReduced() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function apply(state) {
    root.setAttribute('data-motion', state);
    document.querySelectorAll('.motion-toggle').forEach(function (b) {
      b.setAttribute('aria-pressed', state === 'off' ? 'true' : 'false');
    });
  }

  var stored = null;
  try { stored = localStorage.getItem(KEY); } catch (e) {}
  var defaultOff = root.getAttribute('data-motion-default') === 'off';
  apply(stored || (systemReduced() || defaultOff ? 'off' : 'on'));

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.motion-toggle');
    if (!t) return;
    var next = root.getAttribute('data-motion') === 'off' ? 'on' : 'off';
    apply(next);
    try { localStorage.setItem(KEY, next); } catch (err) {}
  });

  /* Fade + rise on the grid, tight stagger. */
  function observe() {
    var items = document.querySelectorAll('.rise:not(.is-in), .draw:not(.is-in)');
    if (!items.length) return;

    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      var batch = entries.filter(function (en) { return en.isIntersecting; });
      batch.forEach(function (en, i) {
        var el = en.target;
        var own = el.getAttribute('data-delay');
        el.style.setProperty('--delay', (own !== null ? parseInt(own, 10) : i * 40) + 'ms');
        el.classList.add('is-in');
        io.unobserve(el);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });

    items.forEach(function (el) { io.observe(el); });
  }
  observe();
  document.addEventListener('shopify:section:load', observe);

  /* Article progress bar. */
  var bar = document.getElementById('progress');
  if (bar) {
    var article = document.getElementById('article-body') || document.body;
    var ticking = false;
    var update = function () {
      var top = article.offsetTop;
      var height = article.offsetHeight - window.innerHeight;
      var p = height > 0 ? (window.scrollY - top) / height : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)) + ')';
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  /* Mobile nav disclosure. */
  var burger = document.querySelector('.header__burger');
  var panel = document.getElementById('header-mobile');
  if (burger && panel) {
    burger.addEventListener('click', function () {
      var open = panel.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
})();
